<div *ngIf="(weeklyCommitmentsRegions$ | async).length">
  <div
    class="m-0 md:p-3 flex flex-col card-with-shadow bg-white p-2 mb-2"
    *ngFor="let region of weeklyCommitmentsRegions$ | async; trackBy: 'id' | trackByKey"
  >
    <div class="flex-1 flex flex-col">
      <div class="text-lg font-bold">
        Driver Count Commitment: <span class="text-blue-500">{{ region.name }}</span>
      </div>
      <div class="flex h-4">
        <div class="w-1/6"></div>
        <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4 flex-1">mon</div>
        <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4 flex-1">tue</div>
        <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4 flex-1">wed</div>
        <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4 flex-1">thu</div>
        <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4 flex-1">fri</div>
        <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4 flex-1">sat</div>
        <div class="text-gray-700 text-xs cap flex justify-center uppercase h-4 flex-1">sun</div>
      </div>
      <div class="flex flex-col flex-1">
        <div class="flex flex-col flex-1" *ngFor="let week of region.weeks; trackBy: 'startsOn' | trackByKey">
          <ng-container *ngIf="week.closed; else notClosed">
            <div class="flex flex-1 h-16">
              <div class="w-1/6 flex items-center justify-center">
                <ng-container *lohiFeatureFlag="'updateCommitmentAnyTime'; else noUpdatingClosedWeeks">
                  <div class="cursor-pointer" (click)="updateCommitment(region, week)">This Week</div>
                </ng-container>
                <ng-template #noUpdatingClosedWeeks>
                  <div>This Week</div>
                </ng-template>
              </div>
              <div class="flex-1 flex-col">
                <div class="flex w-full h-4">
                  <div
                    [class.bg-gray-400]="day.isInThePast"
                    [class.border]="!day.isToday"
                    [class.border]="day.isToday"
                    class="text-black h-4 border-black border-b-0 p-1 flex-1 flex justify-between"
                    *ngFor="let day of week.days; trackBy: 'day' | trackByKey"
                  >
                    <ng-template #NoLoadsMessageTooltip>
                      <div class="flex flex-col" style="max-width: 400px">
                        <div class="whitespace-pre-wrap text-left">{{ day.noLoadsAvailableMessage }}</div>
                        <div class="flex justify-end text-gray-500">
                          {{ day.noLoadsAvailableCreatedAt | standardDate }}
                        </div>
                      </div>
                    </ng-template>
                    <ng-container *ngIf="day.noLoadsAvailableMessage; else empty"
                      ><div [tooltip]="NoLoadsMessageTooltip" content-type="template">ℹ️</div></ng-container
                    >
                    <ng-template #empty><div></div></ng-template>
                    <ng-container *ngIf="day.isToday; else regularDate">
                      <div class="text-blue-500 font-bold text-right text-xl">
                        {{ day.day }}<sup>{{ day.day | ordinal }}</sup>
                      </div>
                    </ng-container>
                    <ng-template #regularDate>
                      <div class="text-gray-600" *ngIf="day.isInThePast">
                        {{ day.day }}<sup>{{ day.day | ordinal }}</sup>
                      </div>
                      <div *ngIf="!day.isInThePast">
                        {{ day.day }}<sup>{{ day.day | ordinal }}</sup>
                      </div></ng-template
                    >
                  </div>
                </div>
                <div class="flex w-full h-8">
                  <ng-container *ngFor="let day of week.days; trackBy: 'day' | trackByKey">
                    <ng-template #NoLoadsMessageTooltip>
                      <div class="flex flex-col" style="max-width: 400px">
                        <div class="whitespace-pre-wrap text-left">{{ day.noLoadsAvailableMessage }}</div>
                        <div class="flex justify-end text-gray-500">
                          {{ day.noLoadsAvailableCreatedAt | standardDate }}
                        </div>
                      </div>
                    </ng-template>
                    <div
                      [tooltip]="NoLoadsMessageTooltip"
                      [class.bg-gray-400]="day.isInThePast"
                      content-type="template"
                      [display]="false"
                      [class.border]="!day.isToday"
                      [class.border]="day.isToday"
                      class="text-black flex flex-col items-center justify-center border-black border-t-0 border-b-0 flex-1 relative"
                    >
                      <ng-container *ngIf="day.latestResponse !== null; else noResponse">
                        <div class="text-xl font-bold">
                          {{ day.latestResponse }}
                        </div>
                        <div class="text-sm text-gray-700">Committed</div>
                      </ng-container>
                      <ng-template #noResponse>
                        <div class="text-xl font-bold">?</div>
                        <div class="text-sm text-gray-700">Committed</div>
                      </ng-template>
                    </div>
                  </ng-container>
                </div>
                <div class="flex w-full h-4">
                  <div
                    [class.bg-gray-400]="day.isInThePast"
                    [class.border]="!day.isToday"
                    [class.border]="day.isToday"
                    class="text-black h-4 border-black border-t-0 py-1 flex-1"
                    *ngFor="let day of week.days; trackBy: 'day' | trackByKey"
                  >
                    <ng-container *ngIf="day.isInThePast; else todayOrFuture">
                      <div
                        class="flex justify-end px-1"
                        [class.text-red-500]="day.driverHourScore < 90"
                        [class.text-green-500]="day.driverHourScore >= 90"
                        [tooltip]="day.driverHourScore + '% of commitment met'"
                        *ngIf="day.driverHourScore !== null"
                      >
                        {{ day.driverHourScore }}%
                      </div>
                    </ng-container>
                    <ng-template #todayOrFuture
                      ><div class="text-xs flex items-center justify-center" *lohiFeatureFlag="'showNeededNumbers'">
                        <span>{{ day.currentRequest || day.latestResponse }} Needed</span>
                        <div
                          class="font-bold"
                          *ngIf="day.currentRequest && day.latestResponse && day.latestResponse !== day.currentRequest"
                          [class.text-red-500]="day.currentRequest && day.latestResponse - day.currentRequest > 0"
                          [class.text-green-500]="day.currentRequest && day.currentRequest - day.latestResponse > 0"
                        >
                          &nbsp;(
                          <span *ngIf="day.currentRequest && day.latestResponse - day.currentRequest > 0">
                            -{{ day.latestResponse - day.currentRequest }}</span
                          >
                          <span *ngIf="!day.currentRequest || day.latestResponse - day.currentRequest === 0">
                            &plusmn;0</span
                          >
                          <span *ngIf="day.currentRequest && day.currentRequest - day.latestResponse > 0">
                            +{{ day.currentRequest - day.latestResponse }}</span
                          >
                          )
                        </div>
                      </div></ng-template
                    >
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #notClosed>
            <div class="flex-1 flex h-12">
              <div
                class="w-1/6 p-1 flex items-center justify-center underline"
                [ngClass]="{ 'font-bold text-blue-500': week.days[0].latestResponse == null }"
              >
                <div class="cursor-pointer" (click)="updateCommitment(region, week)">
                  {{ week.days[0].month | monthName }} {{ week.days[0].day }} -
                  {{ week.days[week.days.length - 1].month | monthName }} {{ week.days[week.days.length - 1].day }}
                </div>
              </div>
              <div class="flex-1 flex-col">
                <div class="flex w-full h-4">
                  <div
                    class="text-black h-4 border border-black border-b-0 p-1 flex-1 flex justify-end"
                    *ngFor="let day of week.days; trackBy: 'day' | trackByKey"
                  >
                    <span
                      >{{ day.day }}<sup>{{ day.day | ordinal }}</sup></span
                    >
                  </div>
                </div>
                <div class="flex w-full h-8">
                  <ng-container *ngFor="let day of week.days; trackBy: 'day' | trackByKey">
                    <ng-template #NoLoadsMessageTooltip>
                      <div class="flex flex-col" style="max-width: 400px">
                        <div class="flex justify-end text-red-500 font-bold">
                          {{ day.noLoadsAvailableCreatedAt | standardDate }}
                        </div>
                        <div class="whitespace-pre-wrap text-left">{{ day.noLoadsAvailableMessage }}</div>
                      </div>
                    </ng-template>
                    <div
                      [tooltip]="NoLoadsMessageTooltip"
                      content-type="template"
                      [display]="false"
                      class="text-black flex flex-col items-center justify-center border border-black border-t-0 flex-1 relative"
                    >
                      <ng-container *ngIf="day.latestResponse !== null; else noResponse">
                        <div class="text-xl font-bold">
                          {{ day.latestResponse }}
                          <!-- <span class="text-blue-500" *ngIf="day.supplyDeficit"> (+{{ day.supplyDeficit }})</span> -->
                        </div>
                        <div class="text-sm text-gray-700">Committed</div>
                      </ng-container>
                      <ng-template #noResponse>
                        <div class="text-xl font-bold">?</div>
                        <div class="text-sm text-gray-700">Committed</div>
                      </ng-template>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #updateResponseModal>
  <ng-container *ngIf="selectedWeek && selectedRegion">
    <div mat-dialog-title>Send Customer an Updated Truck Count</div>
    <div mat-dialog-content>
      <div class="flex flex-col">
        <div>
          <div>This is the number of drivers you have available at all times.</div>
          <div><span class="font-bold">Please Note:</span> This is also applicable to night shifts.</div>
        </div>
        <div class="flex flex-col justify-center mt-2 w-full">
          <ng-container *ngFor="let day of selectedWeek.days; trackBy: 'requestId' | trackByKey; let i = index">
            <ng-container *ngIf="weekForm?.at(i) as fc">
              <div class="flex flex-col lg:flex-row mb-2">
                <div class="w-1/3 flex flex-col justify-center">
                  <div>{{ day.dayOfWeek }}, {{ day.month | monthName }} {{ day.day }}</div>
                  <div *ngIf="day.holidayName" class="text-blue-500">
                    {{ day.holidayName }}
                  </div>
                </div>
                <div class="flex-1 flex flex-col">
                  <mat-form-field>
                    <input
                      type="number"
                      step="1"
                      matInput
                      [formControl]="fc"
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      autocomplete="off"
                    />
                    <div matSuffix>Trucks</div>
                    <!-- <mat-hint
                      ><div class="text-sm text-gray-600" *ngIf="day.latestResponse !== null && day.supplyDeficit > 0">
                        Requesting {{ day.supplyDeficit }} More Trucks
                      </div>
                      <div class="text-sm text-gray-600" *ngIf="day.latestResponse === null && day.supplyDeficit > 0">
                        Requesting {{ day.supplyDeficit }} Trucks
                      </div>
                      <div class="text-sm text-gray-600" *ngIf="day.latestResponse === null && day.supplyDeficit === 0">
                        Requesting {{ day.originalRequest }} Trucks
                      </div>
                    </mat-hint> -->
                    <mat-hint *ngIf="day.currentRequest !== null">
                      Requesting {{ day.currentRequest }} Trucks
                    </mat-hint>
                  </mat-form-field>
                </div>
                <div
                  class="ml-1 flex items-center cursor-default"
                  *ngIf="fc.value < day.originalResponse"
                  matTooltip="This number is lower than your original commitment for this week!"
                >
                  <mat-icon class="text-red-500">warning</mat-icon>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div class="flex justify-end">
        <button mat-raised-button color="primary" (click)="validateEntries()">Send To Customer</button>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #areYouSureModal>
  <div mat-dialog-title>Are you sure?</div>
  <div mat-dialog-content>
    <div *ngIf="holidayWarning$$ | async as warning">
      The following days are generally considered exceptional and your response is above your average response for the
      rest of the week
      <ul class="my-4">
        <li *ngFor="let day of warning.dayList; trackBy: 'holidayName' | trackByKey" class="font-bold">
          {{ day.date }} - <span class="text-blue-500">{{ day.holidayName }}</span>
        </li>
      </ul>
    </div>
  </div>
  <div class="flex justify-between">
    <button mat-button mat-dialog-close>No, edit my entries</button>
    <button mat-raised-button color="primary" (click)="updateCommittedShifts()">Yes, these numbers are correct</button>
  </div>
</ng-template>
